'use client';

import { c as _c } from "react/compiler-runtime";
import { type ReactNode, useEffect, useRef } from 'react';
import { LoadingMorph } from '@extern/ui/loading-morph';
import { usePathname } from 'next/navigation';
import { useAuthEvents } from '@/app/(auth)/_hooks/use-auth-events';
import { useSignUpQ1Variant } from '../_hooks/use-sign-up-q1-variant';
import { AuthLayout } from './auth-layout';
import { CenteredAuthLayout } from './centered-auth-layout';
const CONTROL_LAYOUT_TEXT = <>
    Gain Real Experience.
    <br />
    Build Essential Skills.
    <br />
    Drive Your Career Forward.
  </>;
interface AuthLayoutSwitcherProps {
  children: ReactNode;
}
export function AuthLayoutSwitcher(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const {
    isReady,
    variant
  } = useSignUpQ1Variant();
  const pathname = usePathname();
  const {
    trackAuthScreenViewed
  } = useAuthEvents();
  const lastTrackedPathRef = useRef(null);
  let t1;
  let t2;
  if ($[0] !== isReady || $[1] !== pathname || $[2] !== trackAuthScreenViewed) {
    t1 = () => {
      if (!(isReady && pathname)) {
        return;
      }
      if (lastTrackedPathRef.current === pathname) {
        return;
      }
      if (pathname.includes("/sign-up")) {
        trackAuthScreenViewed("sign_up", "entry", "start");
        lastTrackedPathRef.current = pathname;
        return;
      }
      if (pathname.includes("/sign-in")) {
        trackAuthScreenViewed("sign_in", "entry", "start");
        lastTrackedPathRef.current = pathname;
      }
    };
    t2 = [isReady, pathname, trackAuthScreenViewed];
    $[0] = isReady;
    $[1] = pathname;
    $[2] = trackAuthScreenViewed;
    $[3] = t1;
    $[4] = t2;
  } else {
    t1 = $[3];
    t2 = $[4];
  }
  useEffect(t1, t2);
  if (!isReady) {
    let t3;
    if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
      t3 = <div className="flex min-h-screen w-full flex-col items-center justify-center bg-role-surface"><LoadingMorph /></div>;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    return t3;
  }
  if (variant === "experiment") {
    let t3;
    if ($[6] !== children) {
      t3 = <CenteredAuthLayout>{children}</CenteredAuthLayout>;
      $[6] = children;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    return t3;
  }
  let t3;
  if ($[8] !== children) {
    t3 = <AuthLayout text={CONTROL_LAYOUT_TEXT}>{children}</AuthLayout>;
    $[8] = children;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  return t3;
}